(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/game-guide/assets/javascripts/nav-menu.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/game-guide/assets/javascripts/nav-menu.js');
"use strict";


const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  Link
} = ReactRouterDOM;
const {
  useLocation
} = ReactRouterDOM;
const {
  constants: {
    gameGuideRoutes
  }
} = svs.oddset_kambi.components.game_guide;
const GameGuideMenu = () => {
  const location = useLocation();
  return React.createElement(ItemsMenu, {
    ariaLabel: "Meny f\xF6r spelguiden",
    centered: true,
    className: "oddset-game-guide-menu",
    customer: "sport",
    hiddenScrollbar: true
  }, gameGuideRoutes.map(item => React.createElement(LinkItem, {
    Component: Link,
    key: item.path,
    label: item.label,
    selected: location.pathname === item.path,
    to: item.path
  })));
};
setGlobal('svs.oddset_kambi.components.game_guide.GameGuideMenu', GameGuideMenu);

 })(window);